import TYPES from '@/modules/shared/types';

// Domain
import { ActivityRepository } from '../../domain/repository';
import { ActivityEntity } from '../../domain/entities/activity-entity';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class ActivityHttpRepository implements ActivityRepository {
  @Inject(TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/kuspit/catalogs/activities/{JOB_TYPE_ID}/`;

  execute(job_type_id: string): Promise<Array<ActivityEntity>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint.replace('{JOB_TYPE_ID}', job_type_id))
        .then((response) => {
          response.json()
            .then(({ data, success, message }) => {
              if (success) {
                resolve(data);
              } else {
                reject(new Error(message));
              }
            });
        })
        .catch(reject);
    });
  }
}
